export default __webpack_public_path__ + "static/media/icon-chevron-left.6b1ef92e.svg";